import   axios                            from 'axios';
import { API_URLS                       } from '../urls';
import { BackendResponse                ,
         handleError                    } from '../../dataTypes/backendServicesManagment/types';

import { Payment                        ,
         initializedPayment             ,
         GetPaymentListParams           ,
         EnrichedPayment                ,
         TurnoverAndPaymentCount        } from '../../dataTypes/paymentManagment/types';

import { Purchase                       ,
         initializedPurchase            ,
         initializedEnrichedPurchase    ,
         Item                           ,
         AppliedDiscount                ,
         EnrichedPurchase               } from '../../dataTypes/purchaseManagment/types';


import { convertDateToString            } from '../../dataTypes/timeManagment/utils';



 // Assurez-vous d'importer le store Redux
 // Assurez-vous d'importer le type RootState

import { retrieveUserList               ,
         retrieveUserById               } from '../../store/userManagment/actions';
import { retrieveDetailledIpAddressInformations     ,
         retrieveDetailledIpAddressInformationsByIp } from '../../store/networkManagment/actions';
		 
		 
const transformAppliedDiscounts = (data: any): AppliedDiscount => ({
  type: data.type,
  condition: data.condition,
  value: data.value,
  priceToApplyOn: data.priceToApplyOn
});

const transformItem = (data: any): Item => ({
  productId: data.productId,
  productVariantId: data.productVariantId,
  quantity: data.quantity,
  basePriceCopy: data.basePriceCopy,
  taxRateCopy: data.taxRateCopy,
  totalPrice: data.totalPrice,
  priceCode: data.priceCode,
  priceToPayCopy: data.priceToPayCopy,
  itemDescription: data.itemDescription,
  appliedDiscounts: Array.isArray(data.appliedDiscounts) ? data.appliedDiscounts.map(transformAppliedDiscounts) : [],
});

const transformPurchase = (data: any): Purchase => ({
  id: data.id,
  amount: data.amount,
  comment: data.comment,
  ipAddress: data.ipAddress,
  creationDate: new Date (data.creationDate), 
  cart: Array.isArray(data.cart) ? data.cart.map(transformItem) : [],
  userId: data.userId,
});

const transformPayment = (data: any): Payment => ({
  id: data.id,
  amount: data.amount,
  comment: data.comment,
  ipAddress: data.ipAddress,
  creationDate: new Date (data.creationDate), 
  paymentReference: data.paymentReference,
  transactionId: data.transactionId,
  meansOfPayment: data.meansOfPayment,
  status: data.status,
  isTest: data.isTest,
  bankName: data.bankName,
  purchase: data.purchase ? transformPurchase(data.purchase) : initializedPurchase(),
});


export interface BackendResponse_PaymentList extends BackendResponse<Payment[]> {}

export const getPaymentList = async (params: GetPaymentListParams = {}): Promise<BackendResponse_PaymentList> => {

  let url = `${API_URLS.getPaymentList}`;
//  const params = new URLSearchParams();

    const queryParams = new URLSearchParams();


  if ( params.userEmail            ) queryParams.append ( 'userEmail'        , params.userEmail           );
  if ( params.userId !== undefined ) queryParams.append ( 'userId'           , params.userId.toString()   );
  if ( params.ipAddress            ) queryParams.append ( 'ipAddress'        , params.ipAddress           );

  if ( params.beginningDate        ) 
   {
    const beginningUTC = new Date ( params.beginningDate.getTime() - params.beginningDate.getTimezoneOffset() * 60000 );
    queryParams.append ( 'beginningDateStr' , beginningUTC.toISOString() );
   }
   
  if ( params.endingDate           ) 
   {
	const endingUTC = new Date ( params.endingDate.getTime() - params.endingDate.getTimezoneOffset() * 60000 );
	queryParams.append ( 'endingDateStr' , endingUTC.toISOString() );
   }
   
//  if (params.beginningDateStr) params.append('beginningDateStr', encodeURIComponent(params.beginningDateStr));
//  if (params.endingDateStr) params.append('endingDateStr', encodeURIComponent(params.endingDateStr));
//  if (params.email) params.append('email', encodeURIComponent(params.email));

  if (queryParams.toString()) url += `?${queryParams.toString()}`;

  try {
    const response = await axios.get(url);

    if (response.status === 200 && Array.isArray(response.data)) {
      const payments =  response.data.map(transformPayment);
      return {
        code: 1,
        comment: 'La liste des paiements a été récupérée avec succès.',
        payload: payments,
      };
    } else {
      return handleError<Payment[]>(response.status, 'Réponse non-200 ou données invalides.');
    }
  } catch (error) {

    if (axios.isAxiosError(error)) {
      return handleError<Payment[]>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<Payment[]>(-102, 'Erreur inconnue.');
  }
};

export interface BackendResponse_Payment extends BackendResponse<Payment> {}

export const getPaymentById = async (paymentId: number): Promise<BackendResponse_Payment> => {

  const baseUrl = `${API_URLS.getPaymentById}`;
  const url     = baseUrl.replace('{id}', `${paymentId}`);


  try {
    const response = await axios.get(url);

    if (response.status === 200)
     {
      const payment =  transformPayment (response.data);
      return {
        code: 1,
        comment: 'La liste des paiements a été récupérée avec succès.',
        payload: payment,
      };
    } else {
      return handleError<Payment>(response.status, 'Réponse non-200 ou données invalides.');
    }
  } catch (error) {

    if (axios.isAxiosError(error)) {
      return handleError<Payment>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<Payment>(-102, 'Erreur inconnue.');
  }
};


export interface BackendResponse_EnrichedPaymentList extends BackendResponse<EnrichedPayment[]> {}

export const getEnrichedPaymentList = async ( params: GetPaymentListParams = {} ): Promise<BackendResponse_EnrichedPaymentList> => {

  await retrieveUserList(params);
  await retrieveDetailledIpAddressInformations();

//  const payments = await retrievePaymentList(params);
//  const enrichedPayments = await Promise.all(payments.map(async (payment) => {

  const payments = await getPaymentList (params)

  const enrichedPayments = await Promise.all(payments.payload.map(async (payment) => {
    const defaultPayment  = initializedPayment();
    const defaultPurchase = initializedEnrichedPurchase()  
	
	const user         = await retrieveUserById (payment.purchase.userId) || null;
    const ipDetails    = await retrieveDetailledIpAddressInformationsByIp (payment.ipAddress, payment.purchase.userId);

    const purchase: EnrichedPurchase = {     ////// A REPRENDRE POUR AJOUTER LES ITEMS ACHETES
      ...defaultPurchase,
      ...payment.purchase,
      user: user ?? undefined,
      ipDetails: ipDetails ?? undefined,
    };
	
	
	
    return { ...defaultPayment, ...payment, purchase: purchase ?? undefined };
  }));

  return {
    code: 1,
    comment: 'Enriched payments retrieval complete.',
    payload: enrichedPayments,
  };
};



export interface BackendResponse_TurnoverAndPaymentCount extends BackendResponse<TurnoverAndPaymentCount> {}

export const getTurnoverAndPaymentCount = async ( beginningDate : Date ,
                                                  endingDate    : Date ): Promise<BackendResponse_TurnoverAndPaymentCount> => {

  const url                = `${API_URLS.getPaymentTurnoverAndPaymentCount}`;
  const beginningDateParam = `beginningDateStr=${convertDateToString(beginningDate, 'yyyy-MM-dd')}`
  const endingDateParam    = `endingDateStr=${convertDateToString(endingDate, 'yyyy-MM-dd')}`

  const fullUrl       = `${url}?${beginningDateParam}&${endingDateParam}`

  try
   {
    const response = await axios.get(fullUrl);

    if (response.status === 200)
          {
           const tapc : TurnoverAndPaymentCount =
            {
             turnover     : response.data.turnover,
             paymentCount : response.data.paymentCount
            }

           return {
                    code    : 1,
                    comment : 'Turnover and payment count retrieved with success',
                    payload : tapc,
                  };
          }
     else {
           return handleError<TurnoverAndPaymentCount>(response.status, 'Réponse non-200 ou données invalides.');
          }
   }
  catch (error)
   {

    if (axios.isAxiosError(error))
     {
      return handleError<TurnoverAndPaymentCount>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<TurnoverAndPaymentCount>(-102, 'Erreur inconnue.');
  }
};

export const getTurnoverAndPaymentCountByDate = async ( date : Date ): Promise<BackendResponse_TurnoverAndPaymentCount> => {

  const url       = `${API_URLS.getPaymentTurnoverAndPaymentCountByDate}`;
  const dateParam = `dateStr=${convertDateToString(date, 'yyyy-MM-dd')}`

  const fullUrl   = `${url}?${dateParam}`

  try
   {
    const response = await axios.get(fullUrl);

    if (response.status === 200)
          {
           const tapc : TurnoverAndPaymentCount =
            {
             turnover     : response.data.turnover,
             paymentCount : response.data.paymentCount
            }

           return {
                    code    : 1,
                    comment : 'Turnover and payment count retrieved with success',
                    payload : tapc,
                  };
          }
     else {
           return handleError<TurnoverAndPaymentCount>(response.status, 'Réponse non-200 ou données invalides.');
          }
   }
  catch (error)
   {

    if (axios.isAxiosError(error))
     {
      return handleError<TurnoverAndPaymentCount>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<TurnoverAndPaymentCount>(-102, 'Erreur inconnue.');
  }
};
